export function scrollingText() {
  const blocks = Array.from(document.querySelectorAll('.farlo-ui-scrolling-text'));


  const items = blocks.map(block => {
    const content = block.querySelector('.farlo-ui-scrolling-text__content');
    return { block, content };
  }).filter(Boolean);

  let latestScrollY = 0;
  let ticking = false;

  function onScroll() {
    latestScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(updatePositions);
      ticking = true;
    }
  }

  function updatePositions() {
    const vh = window.innerHeight;

    items.forEach(({ block, content }) => {
      const containerRect = block.getBoundingClientRect();
      const contentRect   = content.getBoundingClientRect();

      const totalSpan = vh + containerRect.height;
      const rawProg   = (vh - containerRect.top) / totalSpan;
      const prog      = Math.min(Math.max(rawProg, 0), 1);

      const distance  = contentRect.width + containerRect.width;
      const offsetX   = containerRect.width - prog * distance;

      content.style.transform = `translateX(${offsetX}px)`;
    });

    ticking = false;
  }

  // Wire up
  window.addEventListener('scroll', onScroll);
  updatePositions();
}
